import { render, staticRenderFns } from "./SuperAdminCounselors.vue?vue&type=template&id=7ff8fc42&"
import script from "./SuperAdminCounselors.vue?vue&type=script&lang=js&"
export * from "./SuperAdminCounselors.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports